import { render, staticRenderFns } from "./ClickAddPerson.vue?vue&type=template&id=11155af6&"
import script from "./ClickAddPerson.vue?vue&type=script&lang=js&"
export * from "./ClickAddPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports